import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-myasc',
  templateUrl: './help-myasc.component.html'
})
export class HelpMyascComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
